import { IonIcon } from '@ionic/react';
import React from 'react';
import { PageHeaderH1 } from './pageHeaderStyles';
import { useHistory } from 'react-router';
import { arrowBackCircle } from 'ionicons/icons';

type PageHeaderProps = {
	title: string;
};
const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
	const history = useHistory();
	return (
		<PageHeaderH1>
			<IonIcon
				icon={arrowBackCircle}
				onClick={() => {
					if (window.history.length > 1) {
						history.goBack();
					} else {
						history.replace('/home');
					}
				}}
			/>
			{title}
		</PageHeaderH1>
	);
};

export default PageHeader;
